import { Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { useMasterData } from 'hooks';
import { Product } from '@spike/product-model';
import { FunctionComponent } from 'react';
import { getPriceBySize } from '../../Utils';
import Area from '../Area';
import ResumeSection, { BodyResumeSection } from '../ResumeSection';

interface Props {
    product: Product;
    onEdit: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            maxWidth: '100%',
            minWidth: 0
        },
        row: {
            display: 'flex',
            flexWrap: 'wrap',
            width: '100%',
            [theme.breakpoints.down(768)]: {
                flexDirection: 'column',
                gap: '12px'
            }
        },
        item: {
            [theme.breakpoints.down(768)]: {
                marginRight: 0,
                minWidth: 0,
                width: '100%'
            },
            [theme.breakpoints.between(768, 'md')]: {
                marginRight: '28px',
                minWidth: '250px'
            },
            [theme.breakpoints.up('lg')]: {
                marginRight: '35px',
                minWidth: '250px'
            }
        },
        itemExtra: {},
        taxContainer: {
            display: 'flex'
        },
        taxNameContainer: {
            width: '65%'
        },
        taxPercentageContainer: {
            width: '35%'
        },
        taxPercentage: {
            fontWeight: 300,
            color: '#7A7A7A !important'
        }
    })
);

export const ResumePricing: FunctionComponent<Props> = props => {
    const classes = useStyles();
    const masterData = useMasterData();

    return (
        <ResumeSection
            title="Pricing"
            {...props}
        >
            <BodyResumeSection>
                <Box className={classes.container}>
                    <Box className={classes.row}>
                        {props.product.businessProduct?.pricing?.price && (
                            <Box className={classes.item}>
                                <Area
                                    title="RETAIL PRICE"
                                    info={getPriceBySize(props.product.businessProduct, masterData)}
                                />
                            </Box>
                        )}

                        {props.product.businessProduct?.pricing?.taxes && (
                            <Box className={classes.item}>
                                <Area
                                    title="TAXES"
                                    childrenAsItem={true}
                                >
                                    {props.product.businessProduct?.pricing.taxes.length > 0 ? (
                                        <Box>
                                            {props.product.businessProduct?.pricing.taxes.map(tax => {
                                                return (
                                                    <Box
                                                        className={classes.taxContainer}
                                                        key={tax.uuid}
                                                    >
                                                        <Box className={classes.taxNameContainer}>
                                                            <Typography>{tax.name}</Typography>
                                                        </Box>
                                                        <Box className={classes.taxPercentageContainer}>
                                                            <Typography className={classes.taxPercentage}>
                                                                {tax.percentage}%
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                );
                                            })}
                                        </Box>
                                    ) : (
                                        <Typography className={classes.itemExtra}>Not Taxable</Typography>
                                    )}
                                </Area>
                            </Box>
                        )}

                        <Box className={classes.item}>
                            <Area
                                title="AVAILABLE FOR CHECKOUT"
                                info={props.product.businessProduct?.availableForCheckout ? 'YES' : 'NO'}
                            />
                        </Box>
                    </Box>
                </Box>
            </BodyResumeSection>
        </ResumeSection>
    );
};

export default ResumePricing;
